import { render, staticRenderFns } from "./statements.vue?vue&type=template&id=494583d4&scoped=true"
import script from "./statements.vue?vue&type=script&lang=js"
export * from "./statements.vue?vue&type=script&lang=js"
import style0 from "./statements.vue?vue&type=style&index=0&id=494583d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494583d4",
  null
  
)

export default component.exports